import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';
import useFeatureDiscoveryFeatureDiscoveryQuery, {
	type useFeatureDiscoveryFeatureDiscoveryQuery$data,
	type useFeatureDiscoveryFeatureDiscoveryQuery$variables,
} from './__generated__/useFeatureDiscoveryFeatureDiscoveryQuery.graphql.ts';

export const preloadFeatureDiscovery = () => {
	return query<
		useFeatureDiscoveryFeatureDiscoveryQuery$data,
		useFeatureDiscoveryFeatureDiscoveryQuery$variables
	>({
		query: useFeatureDiscoveryFeatureDiscoveryQuery,
	});
};
